import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-validator"
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { readonly: Boolean, skip: Boolean, markRequired: Boolean }

  connect() {
    if (this.markRequiredValue && !this.skipValue && !this.readonlyValue) this.markRequired()
    this.validate()
  }

  validate() {
    if (!this.hasSubmitTarget) return

    const filled = this.skipValue || this.inputTargets.every(el => {
      const hiddenGroup = el.parentElement.closest('[data-indicacion-medica-tabulado-target]')
      if (hiddenGroup && hiddenGroup.classList.contains('d-none')) return true

      return el.value && el.value.trim() !== ""
    })

    this.submitTarget.disabled = this.readonlyValue || !filled
  }

  markRequired() {
    this.inputTargets.forEach(el => {
      el.closest(".form-group")?.querySelector("label")?.classList.add("required-field")
    })
  }
}
